import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span
      class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold tracking-wide border shadow-xs"
      [ngClass]="{
        'bg-amber-50 text-amber-700 border-amber-200 badge-amber-glow': status === 'PENDING',
        'bg-indigo-50 text-indigo-700 border-indigo-200': status === 'FORWARDED',
        'bg-orange-50 text-orange-700 border-orange-200': status === 'RETURNED',
        'bg-purple-50 text-purple-700 border-purple-200': status === 'ON_HOLD',
        'bg-emerald-50 text-emerald-700 border-emerald-200 badge-emerald-glow': status === 'APPROVED' || status === 'LIVE' || status === 'active' || status === 'ACTIVE',
        'bg-rose-50 text-rose-700 border-rose-200': status === 'REJECTED' || status === 'inactive',
        'bg-sky-50 text-sky-700 border-sky-200 badge-blue-glow': status === 'TESTING' || status === 'SANDBOX' || status === 'TEST',
        'bg-teal-50 text-teal-700 border-teal-200': status === 'PRODUCTION'
      }"
    >
      <span
        class="w-1.5 h-1.5 rounded-full"
        [ngClass]="{
          'bg-amber-500 animate-pulse': status === 'PENDING',
          'bg-indigo-500': status === 'FORWARDED',
          'bg-orange-500': status === 'RETURNED',
          'bg-purple-500': status === 'ON_HOLD',
          'bg-emerald-500': status === 'APPROVED' || status === 'LIVE' || status === 'active' || status === 'ACTIVE',
          'bg-rose-500': status === 'REJECTED' || status === 'inactive',
          'bg-sky-500 animate-ping': status === 'TESTING'
        }"
      ></span>
      {{ status }}
    </span>
  `
})
export class StatusBadgeComponent {
  @Input() status: string = 'PENDING';
}
